const DEFAULT_STATE = {
  dates: [],
  minSearchVolume: 0,
  isActive: "",
  category: "",
  nhours: "",
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getNhours: (state) => state.nhours,
    getDates: (state) => state.dates,
    getMinSearchVolume: (state) => state.minSearchVolume,
    getisActive: (state) => state.isActive,
    getCategory: (state) => state.category,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setNhours(state, payload) {
      state.nhours = payload;
    },
    setDates(state, payload) {
      state.dates = payload;
    },
    setMinSearchVolume(state, payload) {
      state.minSearchVolume = payload;
    },
    setIsActive(state, payload) {
      state.isActive = payload;
    },
    setCategory(state, payload) {
      state.category = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateNhours({ commit }, payload) {
      commit("setNhours", payload);
    },
    updateDates({ commit }, payload) {
      commit("setDates", payload);
    },
    updateMinSearchVolume({ commit }, payload) {
      commit("setMinSearchVolume", payload);
    },
    updateIsActive({ commit }, payload) {
      commit("setIsActive", payload);
    },
    updateCategory({ commit }, payload) {
      commit("setCategory", payload);
    },
  },
};
